module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/requisition.36a2ee94.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/requisition.png
// module id = 3765
// module chunks = 11